//////LIBRARY//////
import React, { useState, useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import { isEmpty, isUndefined, isNull } from 'lodash'
//////COMPONENTS//////
import { loginActionCreators, languagesActionCreators } from '../../store/actions'
import { uriList } from '../../routings/settings/RouteList'
import SwitchLanguage from '../../components/SwitchLanguage'
import Modals from '../../components/Modals'
import ModalBody from '../../components/Modals/ModalBody'
import ForgotPassword from '../../components/ForgotPassword'
import ForgotLogin from '../../components/ForgotLogin'
//////ASSETS//////
import { ReactComponent as LogoBackground } from '../../assets/images/login/logo-background-pastel-blue.svg'
import { ReactComponent as IconePortrait } from '../../assets/icones/login/friends.svg'
import { ReactComponent as IconeMdp } from '../../assets/icones/login/password-key.svg'
import { ReactComponent as Logo } from '../../assets/images/login/logo-we-deal.svg'
import ViewPasswordFalse from '../../assets/icones/login/password-hide.svg'
import ViewPasswordTrue from '../../assets/icones/login/passord-show.svg'

//////STYLED//////
// layout page login
const LoginLayout = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 14px;
	position: relative;
	width: 100vw;
	height: 100vh;
	margin: auto;
	min-width: max-content;
	min-height: max-content;
`
// logo component
const ImgContent = styled.div`
	display: inherit;
	align-content: center;
	margin-bottom: 100px;
`
// svg bottom left component
const ImgBackground = styled.div`
	position: absolute;
	width: 314px;
	height: 424px;
	bottom: 0px;
	left: 0px;
	overflow: hidden;
`
const Textmdp = styled.p`
	color: ${(props) => props.theme.colors.cancel};
	font-size: ${(props) => props.theme.font.fs};
	cursor: pointer;
	text-decoration: underline;
`
const FlagWrapper = styled.div`
	display: grid;
	align-content: center;
	justify-content: center;
	margin-top: 40px;
	align-items: center;
	grid-template-columns: repeat(10, auto);
	grid-row-gap: 10px;
`
const LoginWrapper = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	align-items: center;
`
const InputWrapper = styled.div`
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 10px;
`
const InputLogin = styled.input`
	height: 45px;
	width: 195px;
	border-radius: 0 3px 3px 0;
	border: 1px solid ${(props) => props.theme.colors.cancel};
	padding-left: 5px;
	box-sizing: border-box;
	font-family: Lato;
	font-size: 14px;
	:focus {
		outline: none !important;
		border-color: ${(props) => props.theme.colors.primary};
	}
	:-webkit-autofill,
	:-webkit-autofill:hover,
	:-webkit-autofill:focus,
	:-webkit-autofill:active {
		transition: background-color 5000s ease-in-out 0s;
		box-shadow: 0 0 0px 1000px ${(props) => props.theme.colors.white} inset;
	}

	position: relative;
`
const EyeClose = styled.img`
	max-height: 20px;
	max-width: 20px;
	position: absolute;
	top: 11px;
	right: 3%;
	cursor: pointer;
`
const EyeOpen = styled.img`
	max-height: 20px;
	max-width: 20px;
	position: absolute;
	top: 13px;
	right: 3%;
	cursor: pointer;
`
const IconeLogin = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	width: 45px;
	height: 45px;
	border-radius: 3px 0 0 3px;
	background-color: ${(props) => props.theme.colors.primary};
`
const IconeLoginPass = styled(IconeLogin)`
	cursor: pointer;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ButtonElement = styled.button`
	border: none;
	width: 240px;
	height: 45px;
	color: white;
	border-radius: 3px;
	font-size: 18px;
	background-color: ${(props) => props.theme.colors.primary};
	cursor: pointer;
	:hover {
		background-color: ${(props) => props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
`
const ErrorInputMsg = styled.div`
	position: absolute;
	left: 250px;
	width: max-content;
	color: ${(props) => props.theme.colors.error};
`
const ErrorFormMsg = styled.div`
	position: absolute;
	top: -40px;
	width: 240px;
	text-align: center;
	color: ${(props) => props.theme.colors.error};
`
const TextModal = styled.div`
	margin: 0;
	padding: 15px 0;
	color: ${(props) => props.theme.colors.primary};
`
//////STYLED//////

const Login = (props) => {
	let history = useHistory()
	let location = useLocation()

	const [showForgotPassword, setShowForgotPassword] = useState(false)

	const [showForgotLogin, setShowForgotLogin] = useState(false)

	const [disabledButton, setDisabledButton] = useState(false)

	const { user, translations, newLanguageSelected, languagesList, languages } = useSelector(
		(state) => ({
			user: state.user,
			translations: state.languages.translations,
			newLanguageSelected: state.languages.newLanguageSelected,
			languagesList: state.languages.items,
			languages: state.languages,
		}),
		shallowEqual
	)

	const actionsLogin = bindActionCreators(loginActionCreators, useDispatch())
	const actionsLanguages = bindActionCreators(languagesActionCreators, useDispatch())

	const { register, handleSubmit, watch, errors } = useForm()

	const onSubmit = (data) => {
		const user = {
			login: data.identifiant,
			password: data.password,
			idLanguage: newLanguageSelected,
		}
		actionsLogin.getLogin(user)
	}

	/////////////////////////////// HANDLER //////////////////////////////////////

	const handleForgotPassword = (data) => {
		const forgotPw = data.forgotPw
		if (!user.forgotPassword.isLoading) {
			actionsLogin.postForgotPassword(forgotPw)
		}
		setDisabledButton(true)
	}

	const [viewPassword, setviewPassword] = useState(false)

	const handleViewPassword = (e) => {
		setviewPassword(true)
		if (viewPassword) {
			setviewPassword(false)
		}
	}

	const handleCloseForgotPw = () => {
		setShowForgotPassword(false)
		actionsLogin.forgotPasswordReset()
		setDisabledButton(false)
	}
	const handlePasswordToLogin = () => {
		handleCloseForgotPw()
		setShowForgotLogin(true)
	}
	const handleForgotLogin = (data) => {
		const forgotLg = data.forgotLg
		if (!user.forgotLogin.isLoading) {
			actionsLogin.postForgotLogin(forgotLg)
		}
		setDisabledButton(true)
	}

	const handleCloseForgotLogin = () => {
		setShowForgotLogin(false)
		actionsLogin.forgotLoginReset()
		setDisabledButton(false)
	}

	const checkUserConnected = () => {
		if (user.isConnected) {
			if (location.pathname === uriList.login) {
				history.push(uriList.home)
			}
		}
	}

	/////////////////////////////// USE EFFECT //////////////////////////////////////

	useEffect(() => {
		checkUserConnected()
	}, [user.isConnected])

	useEffect(() => {
		if (!isEmpty(translations)) return
		if (isEmpty(languagesList)) actionsLanguages.getLanguagesEnabled()
		if (isEmpty(translations) && isNull(languages.selectedLanguage)) actionsLanguages.getTranslationPublicPage(2)
	}, [translations])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<div>
			{/*MODAL FORGOT PASSWORD*/}
			<Modals
				showModal={showForgotPassword}
				closeModalHandler={handleCloseForgotPw}
				title={translations['page__login__forgotPassword_modal_title']}
				icon={true}
			>
				<ModalBody>
					<ForgotPassword
						translations={translations}
						closeModalHandler={handleCloseForgotPw}
						handleForgotPassword={handleForgotPassword}
						passwordToUser={handlePasswordToLogin}
						usrForgotpw={user.forgotPassword}
						disabledButton={disabledButton}
					/>
				</ModalBody>
			</Modals>
			{/*MODAL FORGOT PASSWORD*/}
			{/*MODAL FORGOT LOGIN*/}
			<Modals
				showModal={showForgotLogin}
				closeModalHandler={handleCloseForgotLogin}
				icon={true}
				title={translations['page__login__forgotUsername_modal_title']}
			>
				<ModalBody>
					<ForgotLogin
						translations={translations}
						closeModalHandler={handleCloseForgotLogin}
						handleForgotLogin={handleForgotLogin}
						usrForgotlg={user.forgotLogin}
						disabledButton={disabledButton}
					/>
				</ModalBody>
			</Modals>
			{/*MODAL FORGOT PASSWORD*/}

			<LoginLayout>
				<ImgBackground>
					<LogoBackground />
				</ImgBackground>

				<LoginWrapper>
					<ImgContent>
						<Logo />
					</ImgContent>

					<LoginWrapper>
						<form onSubmit={handleSubmit(onSubmit)}>
							{user.error?.data && <ErrorFormMsg>{translations[user?.error.data.traductionKey]}</ErrorFormMsg>}
							<InputWrapper>
								<IconeLogin>
									<IconePortrait />
								</IconeLogin>
								<InputLogin
									name="identifiant"
									type="text"
									placeholder={translations['page__login__form_username']}
									ref={register({
										required: {
											value: true,
											message: translations['common__text__requiredField'],
										},
										maxLength: {
											value: 150,
											message: '',
										},
									})}
								/>
								{errors.identifiant && <ErrorInputMsg>{errors.identifiant.message}</ErrorInputMsg>}
							</InputWrapper>
							<InputWrapper>
								<IconeLoginPass onClick={() => handleViewPassword()}>
									<IconeMdp />
								</IconeLoginPass>
								{viewPassword ? (
									<div>
										<InputLogin
											name="password"
											type="text"
											placeholder={translations['page__login__form_password']}
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
												maxLength: {
													value: 50,
													message: '',
												},
											})}
										/>
										<EyeOpen src={ViewPasswordTrue} onClick={() => handleViewPassword()} />
									</div>
								) : (
									<div>
										<InputLogin
											name="password"
											type="password"
											placeholder={translations['page__login__form_password']}
											ref={register({
												required: {
													value: true,
													message: translations['common__text__requiredField'],
												},
												maxLength: {
													value: 50,
													message: '',
												},
											})}
										/>
										<EyeClose src={ViewPasswordFalse} onClick={() => handleViewPassword()} />
									</div>
								)}

								{errors.password && <ErrorInputMsg>{errors.password.message}</ErrorInputMsg>}
							</InputWrapper>
							<ButtonElement type="submit">{translations['page__login__button_logIn']}</ButtonElement>
						</form>
					</LoginWrapper>

					<Textmdp
						onClick={() => {
							setShowForgotPassword(true)
						}}
					>
						{translations['page__login__forgotPassword']}
					</Textmdp>
					<Textmdp
						onClick={() => {
							setShowForgotLogin(true)
						}}
					>
						{translations['page__login__forgotUsername']}
					</Textmdp>

					<FlagWrapper>
						<SwitchLanguage scope="public" />
					</FlagWrapper>
				</LoginWrapper>
			</LoginLayout>
		</div>
	)
}

Login.propTypes = {}

export default Login
